/**
 * "1,2 MB" — o tamanho como a pessoa o lê, não em bytes.
 *
 * @param bytes o tamanho
 * @returns o tamanho legível
 */
export function tamanhoLegivel(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} bytes`
  }
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(0)} KB`
  }
  return `${(bytes / (1024 * 1024)).toFixed(1).replace('.', ',')} MB`
}

/**
 * O nome do arquivo sem a extensão, como sugestão de nome do documento.
 *
 * "Proc 9900046819-2023 - Peça 174 - Termo de Referência.pdf" vira o nome sem o ".pdf"; a pessoa
 * encurta se quiser. Sugerir é melhor que deixar o campo vazio: o nome é obrigatório e a maioria
 * aceitaria o do arquivo.
 *
 * @param nomeDoArquivo o nome que o navegador deu
 * @returns a sugestão, com no máximo 200 caracteres
 */
export function nomeSugerido(nomeDoArquivo: string): string {
  return nomeDoArquivo.replace(/\.[^.]+$/, '').replace(/[_]+/g, ' ').trim().slice(0, 200)
}
